/** Honest, tiny, never a warning colour: marks a sample gardener kept by Root & Rose. */
export function SampleTag({ id, className = "" }) {
  return <span data-testid={`sample-tag-${id}`} className={`text-[10px] lowercase font-semibold px-1.5 py-0.5 rounded-full bg-stone-100 text-stone-500 border border-stone-200 ${className}`}>sample</span>;
}

export const SAMPLE_GARDEN_LINE = "A sample gardener kept by Root & Rose while the community grows.";
